import React from 'react'
import CommonHeader from '../CommonHeader'
import TableList from './TableList'

export default function Index() {
    return (
        <>
            <CommonHeader />
            <TableList />
        </>
    )
}
